{
  "until": "{{duration}} avant {{prayer}}",
  "begin_focus": "Lancer le focus",
  "add_task": "Ajouter une tâche",
  "more_tasks": "+{{count}} autres",
  "fajr_at": "Fajr à {{time}}",
  "schedule_title": "Aujourd'hui",
  "plan_my_day": "Planifier ma journée",
  "planning": "Planification…",
  "suggested": "Suggéré",
  "keep_plan": "Garder le plan",
  "undo_plan": "Annuler",
  "plan_error": "Planification impossible pour l'instant. Réessayez.",
  "plan_empty": "Rien à planifier pour l'instant — ajoutez d'abord une tâche.",
  "plan_settled": "Tout est déjà à sa place.",
  "view_list": "Liste",
  "view_switch_aria": "Basculer entre la vue liste et la vue jour",
  "unassigned": "Non planifiées",
  "assign_title": "Bloc de prière",
  "no_block": "Aucun bloc",
  "assign_aria": "Assigner à un bloc de prière",
  "open_schedule_aria": "Ouvrir le programme du jour",
  "focus_session_label": "{{block}} · Focus",
  "block_hero": "Travail profond jusqu'à {{prayer}}",
  "moments_away": "{{prayer}} est dans quelques instants",
  "block_clear": "Tout est fait — reposez-vous jusqu'à {{prayer}}",
  "alhamdulillah": "Alhamdoulillah",
  "exit_hint": "Esc pour sortir en silence",
  "exit_hint_touch": "Touchez ✕ pour sortir en silence",
  "mark_done_aria": "Marquer la tâche comme terminée",
  "quick_add_placeholder": "Ajouter à ce bloc…",
  "focus_task_aria": "Se concentrer sur cette tâche"
}
